// Mock data service for development
export const mockData = {
  // User identity
  user: {
    email: "bryankidd@bkonlinesolutions.com",
    uuid: "user-12345-abcde",
    ts: new Date().toISOString()
  },
  
  // Bot data
  bots: [
    {
      id: "bot-001",
      name: "XRP/USDT DCA Bot",
      status: "active",
      strategy: "dca",
      pair: "XRP/USDT",
      mode: "paper",
      created: "2025-01-15T10:00:00Z"
    },
    {
      id: "bot-002", 
      name: "BTC/USDT Momentum",
      status: "active",
      strategy: "momentum",
      pair: "BTC/USDT",
      mode: "live",
      created: "2025-01-14T15:30:00Z"
    }
  ],
  
  // Position data
  positions: [
    {
      id: "pos-001",
      pair: "XRP/USDT",
      side: "long",
      size: 1000,
      entry: 0.58,
      current: 0.62,
      pnl: 68.97,
      status: "open"
    },
    {
      id: "pos-002",
      pair: "BTC/USDT", 
      side: "short",
      size: 0.01,
      entry: 42000,
      current: 41800,
      pnl: 20.00,
      status: "open"
    }
  ],
  
  // Trade data
  trades: [
    {
      id: "trade-001",
      pair: "XRP/USDT",
      side: "buy",
      size: 500,
      price: 0.58,
      timestamp: "2025-01-15T10:15:00Z"
    },
    {
      id: "trade-002",
      pair: "XRP/USDT",
      side: "buy", 
      size: 500,
      price: 0.59,
      timestamp: "2025-01-15T11:00:00Z"
    },
    {
      id: "trade-003",
      pair: "BTC/USDT",
      side: "sell",
      size: 0.005,
      price: 42000,
      timestamp: "2025-01-14T16:00:00Z"
    }
  ]
};




